import "./Title.sass";

function Title({ text, id }) {
    return (
        <div className="section-title">
            <h2 id={id} className="section-title__text">
                {text}
            </h2>
        </div>
    );
}

export default Title;
